import React, {useEffect, useState} from 'react'
import {getClients} from '../../../components/requests'
import {Tooltip} from 'react-tooltip'

interface ModeleClient {
  id: number
  nom: string
  prenom: string
  actif: boolean
  group: string | null
}

const SearchBar = (props, {placeholder}: {placeholder: string}) => {
  const {
    close,
    setClose,
    setClientId,
    clientId = 0,
    setIsClientSociety,
    choicedDemandeSource,
    setTempClientId,
    setTempClient,
    refRechercheClient,
    isPrevious,
    searchTerm,
    setSearchTerm,
  } = props
  // const [searchTerm, setSearchTerm] = useState<any>('') // Texte de recherche
  const [filteredData, setFilteredData] = useState<ModeleClient[]>([]) // Données filtrées
  const [clientFound, setClientFound] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [disable, setDisable] = useState<boolean>(true)

  const Surligner = (text: string, term: string) => {
    if (!term || !text) return text
    const termList = term.split(' ')
    let result = text
    termList?.forEach((term) => {
      if (term.trim() !== '') {
        const regex = new RegExp(`(${term.trim()})`, 'gi')
        result = result.replace(regex, '<mark>$1</mark>')
      }
    })
    return result
  }
  // Désactivation bouton de rechercher client
  useEffect(() => {
    searchTerm.length != 0 ? setDisable(false) : setDisable(true)
  }, [searchTerm])

  // Debounce de 500ms sur la saisie
  useEffect(() => {
    if (searchTerm.length === 0) return

    const timer = setTimeout(() => {
      handleSearch()
    }, 500)

    return () => clearTimeout(timer)
  }, [searchTerm])

  // Gestion de la recherche
  const handleSearch = () => {
    setClose(false)
    if (searchTerm.length != 0) {
      setLoading(true)
      getClients(1, searchTerm, '', '').then((res) => {
        setLoading(false)
        if (res.data.length != 0) {
          setFilteredData(res.data)
          setClientFound(false)
        } else {
          setClientFound(true)
          setFilteredData([])
        }
      })
    }
  }

  const handleSelectedCLient = (client) => {
    setTempClientId(client?.id)
    // setClientId(client?.id)
    setTempClient(client)
    // setIsConfirmEdit(true)
    if (client.professionnel) {
      setIsClientSociety(true)
    } else {
      setIsClientSociety(false)
    }
  }

  const handleToogle = (objClient, ispro, value) => {
    return (
      <>
        <a
          onClick={() => handleSelectedCLient(objClient)}
          style={{cursor: 'pointer'}}
          className='text-dark text-hover-primary d-block fs-6 mb-0'
          data-bs-target={ispro ? '#choixContactModal' : '#exampleModalSearchV'}
          data-bs-toggle='modal'
          data-bs-dismiss='modal'
          data-tooltip-id='modal-tooltip'
          data-tooltip-content={ispro ? 'Choisir contact' : 'Effectuer une demande'}
          data-tooltip-place='top'
          dangerouslySetInnerHTML={{__html: value}}
        ></a>
      </>
    )
  }

  const showCodeClient = (id, auto, moto, indus) => {
    let allCode = false
    if (auto || moto || indus) {
      allCode = true
    }
    const style = {background: '#9ac33124', color: '#9AC331'}
    return (
      <>
        <span className='badge badge-light-success me-2' style={style}>
          Koena
        </span>
        {allCode ? (
          <>
            {auto && (
              <span className='badge me-2 border border-danger' style={{color : '#b92222e3', backgroundColor:'#c41a1a2b'}}>
                CodeAAuto : {auto}
              </span>
            )}
            {moto && (
              <span className='badge me-2 border border-warning' style={{color : 'goldenrod', backgroundColor:'#daa52026'}}>
                CodeAMoto : {moto}
              </span>
            )}
            {indus && (
              <span className='badge badge-light-success me-2 border border-success'>
                CodeAIndus : {indus}
              </span>
            )}
          </>
        ) : (
          <span></span>
        )}
      </>
    )
  }

  return (
    <>
      <div>
        <div className='bg-white sticky-top pb-4' style={{top: '-23px', zIndex: 1}}>
          <label className='required mb-1' style={{fontSize: '1.17em'}} htmlFor='client'>
            Client
          </label>
          <div className='d-flex gap-2'>
            <input
              type='text'
              placeholder={placeholder || 'Rechercher...'}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className='form-control form-control-solid'
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSearch()
                }
              }}
            />

            <button
              type='button'
              className={`btn btn-light border-0 input-group-append h-100 ${
                disable ? 'disabled' : ''
              }`}
              onClick={() => handleSearch()}
              disabled={disable}
              ref={refRechercheClient}
            >
              {loading ? (
                <span className='spinner-border spinner-border-sm align-middle w-20px h-20px'></span>
              ) : (
                <i className='fas fa-search text-secondary fs-1'></i>
              )}
            </button>
          </div>
        </div>

        {!close && clientFound && (
          <h6 className='alert alert-danger d-flex justify-content-center mt-10'>
            Aucun résultat trouvé.
          </h6>
        )}

        {!close && filteredData.length > 0 && (
          <div
            className='d-flex justify-content-between align-items-center flex-column gap-5'
            style={{padding: 0}}
          >
            {filteredData.length &&
              filteredData
                ?.filter((client) => (isPrevious ? client?.[0]?.id !== Number(clientId) : true))
                ?.map((client) => {
                  const nomPrenom = (client[0]?.nom ?? '') + ' ' + (client[0]?.prenom ?? '')
                  const titreTexte = client[0]?.professionnel ? client[0]?.nomSociete : nomPrenom
                  return (
                    <div
                      className={`w-100 border p-5 border-gray-300 border-light btn-hover-primary btn btn-light ${
                        !choicedDemandeSource && 'disabled'
                      }`}
                      style={{
                        borderRadius: '8px',
                        cursor: choicedDemandeSource ? 'pointer' : 'not-allowed',
                        background: 'none',
                      }}
                      onClick={() => handleSelectedCLient(client[0])}
                      data-bs-target='#choixContactModal'
                      data-bs-toggle='modal'
                      data-bs-dismiss='modal'
                      data-tooltip-id='modal-tooltip'
                      data-tooltip-content='Choisir contact'
                      data-tooltip-place='top'
                      key={client.id}
                    >
                      <div className='d-flex justify-content-between align-items-center'>
                        <h5 dangerouslySetInnerHTML={{__html: Surligner(titreTexte, searchTerm)}} />
                        <span
                          className={`d-flex justify-content-between badge ${
                            !client[0]?.actif ? 'badge-light-danger' : 'badge-light-primary'
                          }`}
                        >
                          {!client[0]?.actif ? 'Non actif' : 'Actif'}
                        </span>
                      </div>
                      {client[0]?.professionnel && (
                        <div className='d-flex fw-semibold text-muted gap-2'>
                          <span
                            dangerouslySetInnerHTML={{__html: Surligner(nomPrenom, searchTerm)}}
                          />
                        </div>
                      )}
                      <div className='d-flex text-muted fw-light fs-6 gap-2 mb-2'>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: Surligner(client[0]?.adresse ?? '', searchTerm),
                          }}
                        />
                        <span
                          dangerouslySetInnerHTML={{
                            __html: Surligner(client[0]?.codePostal ?? '', searchTerm),
                          }}
                        />
                        <span
                          dangerouslySetInnerHTML={{
                            __html: Surligner(client[0]?.ville ?? '', searchTerm),
                          }}
                        />
                      </div>
                      <div className='d-flex gap-2 pt-1'>
                        <div className={'text-start'}>
                          <span className='badge badge-light text-black'>
                            {' '}
                            {client[0]?.professionnel ? 'Société' : 'Particulier'}
                          </span>
                        </div>
                        <div className={'text-start'}>
                          {showCodeClient(
                            client[0]?.id,
                            client[0]?.codeClientAAuto,
                            client[0]?.codeClientAMoto,
                            client[0]?.codeClientAIndus
                          )}
                        </div>
                        <div className={'text-gray-900 fs-7 text-end ms-auto'}>{client?.group}</div>
                      </div>
                    </div>
                  )
                })}
          </div>
        )}
      </div>
      {/*Affichage du tooltip*/}
      <Tooltip id='modal-tooltip' style={{zIndex: 2}} />
    </>
  )
}

export default SearchBar
